var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEacnew(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "katman_2",
    "data-name": "katman 2",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 17.01 17.01",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: #1d1d1b;\n        fill-rule: evenodd;\n      }\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "katman_1",
    "data-name": "katman 1"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M11.34,0v16.98h-1.87v-7.51h-1.91v7.51h-1.89V0h5.67ZM9.43,1.92h-1.85v5.63h1.85V1.92Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "3.78 0 3.78 1.87 1.91 1.87 1.91 7.54 3.75 7.54 3.75 9.44 1.91 9.44 1.91 15.11 3.76 15.11 3.76 17.01 0 17.01 0 0 3.78 0"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "17.01 17.01 13.23 17.01 13.23 0 17.01 0 17.01 1.89 15.14 1.89 15.14 15.12 17.01 15.12 17.01 17.01"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEacnew);
export default __webpack_public_path__ + "static/media/eacnew.67f241087120477ca7f7d1d69d06e77b.svg";
export { ForwardRef as ReactComponent };